import React from 'react';
import colors from 'theme/_colors.scss';
import {
    IconFault,
    IconWarningType,
    IconInfoType
} from 'svgIcons/MotionPortalIcons';

export const FETCH_GATEWAY_EVENTS_LOG_SETTINGS = 'gatewayEventsLog/FETCH_GATEWAY_EVENTS_SETTINGS';
export const FETCH_GATEWAY_EVENTS_LOG = 'gatewayEventsLog/FETCH_GATEWAY_EVENTS';
export const LOAD_MORE_GATEWAY_EVENTS = 'gatewayEventLog/LOAD_MORE_GATEWAY_EVENTS';
export const SET_GATEWAY_EVENT_LOG_FILTERS = 'gatewayEventLog/SET_GATEWAY_EVENT_LOG_FILTERS';
export const RESET_GATEWAY_EVENT_LOG_FILTERS = 'gatewayEventLog/RESET_GATEWAY_EVENT_LOG_FILTERS';
export const FETCH_GATEWAY_EVENTS_ATTACHMENT = 'gatewayEventLog/FETCH_GATEWAY_EVENTS_ATTACHMENT';
export const FETCH_GATEWAY_EVENTS_ATTACHMENT_SETTINGS = 'gatewayEventLog/FETCH_GATEWAY_EVENTS_ATTACHMENT_SETTINGS';
export const CHECK_DOWNLOAD_LOGS_LIMIT = 'gatewayEventLog/CHECK_DOWNLOAD_LOGS_LIMIT';
export const CHECK_DOWNLOAD_LOGS_LIMIT_SETTINGS = 'gatewayEventLog/CHECK_DOWNLOAD_LOGS_LIMIT_SETTINGS';
export const DOWNLOAD_LOGS_ZIP = 'gatewayEventLog/DOWNLOAD_LOGS_ZIP';
export const DOWNLOAD_LOGS_ZIP_SETTINGS = 'gatewayEventLog/DOWNLOAD_LOGS_ZIP_SETTINGS';
export const RESET_DOWNLOAD_LOGS_STATE = 'gatewayEventLog/RESET_DOWNLOAD_LOGS_STATE';
export const CLEAR_STORE = 'gatewayEventLog/CLEAR_STORE';

export const INITIAL_PAGE_SIZE = 1000;
export const LOAD_MORE_PAGE_SIZE = 1000;
export const MAX_SEARCH_LENGTH = 50;
export const MIN_FILENAME_SEARCH_LENGTH = 5;

export const FilterFields = {
    EVENT_NAME: 'eventName',
    DCU_SERIAL_NUMBER: 'dcuSerialNumber',
    ORGANIZATION_ID: 'organizationId',
    ORGANIZATION_NAME: 'organizationName',
    USER_EMAIL: 'userEmail'
};

export const EventTypeGatewayApplicability = {
    ALL: 0,
    SMART_SENSOR: 1,
    SMART_SENSOR_DCU: 2,
    DRIVE: 3
};

export const EventTypeIDs = {
    FAULT: 'Fault',
    WARNING: 'Warning',
    INFO: 'Info',
    DEBUG: 'Debug'
};

export const EventTypesIconWithName = [
    {
        typeID: EventTypeIDs.FAULT,
        icon: <IconFault />
    },
    {
        typeID: EventTypeIDs.WARNING,
        icon: <IconWarningType />
    },
    {
        typeID: EventTypeIDs.INFO,
        icon: <IconInfoType color={colors.jungleGreen} />
    }
];

export const EventTypes = [
    {
        typeID: EventTypeIDs.FAULT,
        icon: <IconFault />,
        label: 'ABB.Powertrain.Frontend.lblEventListEventTypeFault',
        applicableTo: EventTypeGatewayApplicability.ALL
    },
    {
        typeID: EventTypeIDs.DEBUG,
        icon: <IconFault />,
        label: 'ABB.Powertrain.Frontend.lblEventListEventTypeDebug',
        applicableTo: EventTypeGatewayApplicability.SMART_SENSOR_DCU
    },
    {
        typeID: EventTypeIDs.WARNING,
        icon: <IconWarningType />,
        label: 'ABB.Powertrain.Frontend.lblEventListEventTypeWarning',
        applicableTo: EventTypeGatewayApplicability.ALL
    },
    {
        typeID: EventTypeIDs.INFO,
        icon: <IconInfoType color={colors.jungleGreen} />,
        label: 'ABB.Powertrain.Frontend.lblEventListEventTypeInfo',
        applicableTo: EventTypeGatewayApplicability.ALL
    }
];


export const SMART_SENSOR_DCU = 'Gateway';
export const SMART_SENSOR = 'SmartSensor';
export const APP = 'App';
export const DRIVE_DCU = 'DriveGateway';

export const EventReportType = {
    MAINTENANCE: 'MAINTENANCE',
    STATISTICS: 'STATISTICS',
    TRAFFIC_REPORT: 'DATATRAFFIC',
    SENSOR_REPORT: 'SensorError',
    APP_LOG: 'APPLOG'
};

export const GatewayEventTabType = {
    ALL: 'ALL',
    LOG: 'LOG',
    REPORT: 'REPORT'
};

// Static report type button definitions - used for SmartSensor DCU Report Type filter.
// TODO: verify backend API keys before wiring these values into API requests.
export const ReportTypes = [
    {
        typeID: EventReportType.MAINTENANCE,
        label: 'ABB.Powertrain.Frontend.gatewayEventFilterReportMaintenance'
    },
    {
        typeID: EventReportType.STATISTICS,
        label: 'ABB.Powertrain.Frontend.gatewayEventFilterReportStatistics'
    },
    {
        typeID: EventReportType.TRAFFIC_REPORT,
        label: 'ABB.Powertrain.Frontend.gatewayEventFilterReportTraffic'
    },
    {
        typeID: EventReportType.SENSOR_REPORT,
        label: 'ABB.Powertrain.Frontend.gatewayEventFilterReportSensor'
    }
];

export const LOCAL_DATE_FORMAT = 'MM/DD/YYYY HH:mm:ss';
